import React, { useState, useEffect } from 'react';
import banner1 from "../assets/Banner1.png";
import banner from "../assets/New.jpg";
import banner3 from "../assets/Banner3.png";
import banner1Phone from "../assets/Banner1Phone.png";
import banner1Ipad from "../assets/Banner1Ipad.png";
import bannerPhone from "../assets/NewPhone.jpg";
import bannerIpad from "../assets/NewIpad.jpg";
import banner3Phone from "../assets/Banner3Phone.png";
import banner3Ipad from "../assets/Banner3Ipad.png";

const BannerCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [screenSize, setScreenSize] = useState<'desktop' | 'tablet' | 'phone'>('desktop');

  const banners = [
    {
      id: 1,
      desktop: banner1,
      tablet: banner1Phone,
      phone: banner1Ipad,
      alt: "Fashion Banner 1"
    },
    {
      id: 2,
      desktop: banner,
      tablet: bannerIpad,
      phone: bannerPhone,
      alt: "Fashion Banner 2"
    },
    {
      id: 3,
      desktop: banner3,
      tablet: banner3Phone,
      phone: banner3Ipad,
      alt: "Fashion Banner 3"
    }
  ];

  // Detect screen size dynamically
 // Corrected
const updateScreenSize = () => {
  if (window.innerWidth <= 480) {
    setScreenSize('phone');    // ✅ Mobile devices
  } else if (window.innerWidth <= 1024) {
    setScreenSize('tablet');   // ✅ iPad/tablets
  } else {
    setScreenSize('desktop');  // ✅ Desktop
  }
};
  useEffect(() => {
    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % banners.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [banners.length]);

  const goToSlide = (index: number) => setCurrentSlide(index);

  return (
    <div className="sticky z-40 bg-white shadow-sm">
      <div className="relative w-full overflow-hidden">
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {banners.map((banner, index) => {
            const imgSrc =
              screenSize === 'phone'
                ? banner.phone
                : screenSize === 'tablet'
                ? banner.tablet
                : banner.desktop;

            return (
              <div key={banner.id} className="min-w-full relative">
                <img
                  src={imgSrc}
                  alt={banner.alt}
                  className="w-full h-auto object-cover"
                  loading={index === 0 ? "eager" : "lazy"}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent"></div>
              </div>
            );
          })}
        </div>

        {/* Dots */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {banners.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-200 ${
                currentSlide === index
                  ? 'bg-white scale-110'
                  : 'bg-white/50 hover:bg-white/75'
              }`}
              aria-label={`Go to banner ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BannerCarousel;
